// Angular
import {ErrorHandler, Injectable} from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error ?? '');
    const isStaleChunk = /Cannot find module|Loading chunk|ChunkLoadError|dynamically imported module/i.test(message);
    if (isStaleChunk && !sessionStorage.getItem('chunk-reload')) {
      sessionStorage.setItem('chunk-reload', '1');
      location.reload();
      return;
    }
    console.error(error);
  }
}
